module.exports = __webpack_public_path__ + "static/media/cancel-service_5.7c5babf8.png";